import { render, staticRenderFns } from "./ProfilePhoto.vue?vue&type=template&id=35d7945a&scoped=true"
import script from "./ProfilePhoto.vue?vue&type=script&lang=js"
export * from "./ProfilePhoto.vue?vue&type=script&lang=js"
import style0 from "./ProfilePhoto.vue?vue&type=style&index=0&id=35d7945a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d7945a",
  null
  
)

export default component.exports